import { render, staticRenderFns } from "./UserActivityLogOutbox.vue?vue&type=template&id=51b2479b&scoped=true"
import script from "./UserActivityLogOutbox.vue?vue&type=script&lang=js"
export * from "./UserActivityLogOutbox.vue?vue&type=script&lang=js"
import style0 from "./UserActivityLogOutbox.vue?vue&type=style&index=0&id=51b2479b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b2479b",
  null
  
)

export default component.exports